import type { ICellRendererParams } from 'ag-grid-community'
import type { ReactElement } from 'react'
import type { ICluster, TScore } from '~/types/cluster'

import ClusterScore from '~/components/ClusterScore'

import './styles.scss'

export interface Props {
  cellScore: TScore
  scale?: 25 | 100
  tooltipScores?: TScore[]
}

const ClusterScoreCellRenderer = ({ value }: ICellRendererParams<ICluster, Props>): ReactElement => {
  if (!value) return <div />

  const { cellScore, scale, tooltipScores } = value

  return (
    <div className="score-cell-renderer">
      <ClusterScore cellScore={cellScore} scale={scale} tooltipScores={tooltipScores} />
    </div>
  )
}

export default ClusterScoreCellRenderer
